import { deleteTransactionApi, getAccountList, getPayment } from "_services";
import { UserContext } from "context";
import { utils } from "helper";
import {
  AddExpensesModal,
  AdvanceBalanceModal,
  AtPartyPointModal,
  ClaimMarketModal,
  ClaimOwnModal,
  ConfirmModalFor,
  ConsignorFreightModal,
  ExpenseMarket,
  MakePaymentModal,
  OtherOwnModal,
  PartyClaimModal,
  PayDriverOwn,
  PayFuelModal,
  PaymentVoucher,
  TripChargesOwn,
} from "modals";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import StorageService from "utils/StorageServices/StorageServices";
import CustomPagination from "components/CustomPagination";
import { Images } from "constants";
import toast from "react-hot-toast";

import { TableOfDetails } from "components/common";

const UnderApprove = (props) => {
  const { activeTab, filter,  } = props;
  const { masterData, setBankDetails, userSettingPermission, allMenu } = useContext(UserContext);
  const [paymentList, setPaymentList] = useState([]);
  const [showMakePayment, setShowMakePayment] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [activeStatus, setActiveStatus] = useState();
  const [isOpenSmallModal, setIsOpenSmallModal] = useState(false);
  const [textState, setTextState] = useState(0);
  const itemsPerPage = 10;
  const [totalItems, setTotalItems] = useState(0);
  const [offSet, setOffset] = useState(1);
  const [isOpenFreight, setIsOpenFreight] = useState({ open: false, type: "" });
  const [details, setDetails] = useState("");
  const [isOpenClaim, setIsOpenClaim] = useState(false);
  const [isOpenExpense, setIsOpenExpense] = useState({ open: false, type: "" });
  const [isOpenOwnExpense, setIsOpenOwnExpense] = useState({
    open: false,
    type: "",
  });
  const [isOpenFuel, setIsOpenFuel] = useState({ open: false, type: "" });

  const [tripChargesOpen, setTripChargesOpen] = useState(false);
  const [isOpenOwnClaim, setIsOpenOwnClaim] = useState(false);
  const [isOpenPayDriver, setIsOpenPayDriver] = useState(false);
  const [isOpenCharge, setIsOpenCharges] = useState({ open: false, type: "" });
  const [isOpenPartyClaim, setIsOpenPartyClaim] = useState(false);
  const [accountList, setAccountList] = useState([]);
  const [paymentVoucherOpen, setPaymentVoucherOpen] = useState(false);

  const [isOpenGeneralExpense, setIsOpenGeneralExpense] = useState({
    open: false,
    title: "",
  });

  const [confirmModalShow, setConfirmModalShow] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false)
  const masterChildPayment = allMenu?.find((i) => i?.label === "Payment Approval");
  const morePermissionCheck = masterChildPayment?.more_permissions?.find((i) => i?.label == "Payment From CB")

  const columnsDetails = [
    { header: "Date", accessor: "tADate" },
    { header: "Voucher No", accessor: "voucherDetails" },
    { header: "Description", accessor: "category" },
    { header: "Transaction Details", accessor: "type_sub_type" },
    { header: "From Account", accessor: "fromDetailsAcc" },
    { header: "To Account", accessor: "suplierDetails" },
    { header: "Account Details", accessor: "transactionType" },
    { header: "Requested by", accessor: "requestedby" },
    { header: "Attachment", accessor: "attechmentFile" },
    { header: "Amount", accessor: "totalamount" },
  ]

  const accessorDetailsList = (data) => {

    const listArray = data?.map((item, i) => ({
      ...item,
      serial: i + 1,
      tADate: (
        <>
          {" "}
          <div className="_dateNtime">
            {" "}
            <span className="_tblText">
              {utils.formatDateMonth(item?.date)}
            </span>
          </div>

        </>
      ),

      suplierDetails: (
        <>
          <div >
            {/* <p className='__lgtPara'>Supplier</p> */}
            <div className='_dateNtime'><span className='_tblText'>{item?.to_account?.name && item?.to_account?.name}</span></div>
            <div className='_dateNtime'><span className='_tblText'>{item?.to_account?.pan_no && `PAN- ${item?.to_account?.pan_no}`}</span></div>
          </div>

        </>
      ),

      voucherDetails: (
        <>
          <div >
            <Link onClick={() => setPaymentVoucherOpen(item)}>
              {item?.voucher_no || ""}
            </Link>
          </div>

        </>
      ),
      transactionType: (
        <>
          {item?.vendor_bank_account !== null ? <div className='__accDetails_holder'>
            <p className='_tblText'>{`A/c Holder-  ${item?.vendor_bank_account?.account_name || ""}`}</p>
            <p className='_tblText'>{`A/c Number- ${item?.vendor_bank_account?.account_number || ""}`}</p>
            <p className='_tblText'>{`IFSC- ${item?.vendor_bank_account?.ifsc_code || ""}`}</p>
          </div> : "-"}
        </>
      ),
      TripNumber: (
        <>
          <div className="__locationWid_bx">
            <span className="_tblText">{item?.vendor_detail?.name || ""}</span>
          </div>
        </>
      ),
      category: (
        <>
          <div>
            <p className='_tblText'>{item?.description || ""}</p>
            <p className='_tblText'>{item?.trip?.route_name || ""}</p>
            {
              (item?.trip?.trip_number && item?.trip?._id) ? 
              <p className='_tblText'>{<Link to={`/trip/addtrip/dispatched/${item?.trip?._id}`}>{`Trip #${item?.trip?.trip_number || ""}`}</Link>}</p>
              : <> - </>
            }
          </div>
        </>
      ),
      type_sub_type: (
        <>
          <div>
            <p className='_tblText'>{item?.sub_type_name || ""}</p>
            <p className='_tblText'>{item?.type_name || ""}</p>
            <p className='_tblText'>{item?.transaction_no || ""}</p>
          </div>
        </>
      ),

      fromDetailsAcc: (
        <>

          <p className='__lgtPara'>{item?.payment_mode?.name || ""}</p>
          <div className='_dateNtime'><span className='_tblText'>{`${item?.payment_mode?.account?.name || ""}`}</span></div>
        </>
      ),
      toAcc: (
        <>
          {" "}
          <div className="__locationWid_bx">
            <span className="_tblText"> {item?.to_account?.name || ""}</span>
          </div>
        </>
      ),

      createAt: (
        <>
          <div className="__locationWid_bx">
            <span>
                  { item?.created_by?.full_name ||"-----"}
            </span>
          </div>
        </>
      ),

      descriptionDetails: (
        <>
          <div>
            {" "}
            <Link to={`/trip/addtrip/dispatched/${item?.trip?._id}`}>
              {" "}
              {item?.trip?.trip_number
                ? `${item?.trip?.trip_number}`
                : "----"}{" "}
            </Link>
          </div>
          <div>
            {item?.trip?.route_name ? `${item?.trip?.route_name}` : ""}{" "}
            {item?.trip?.route_name && item?.description ? " | " : ""}
            {item?.description ? `${item?.description}` : ""}
          </div>
        </>
      ),
       attechmentFile: <>{item?.file?.length}</>,
      account: <>5000</>,
      moreAction: (
        <div className='__hrd_TDbx'>
          <div className='__pmtActionBtns'>
            <button className='__pmtApprovBtn anime-btn' onClick={() => {
              handleButtonClick({ i: 3, item: item });

              setActiveStatus(3);
            }}>Approve</button>
            <button className='__pmtHoldBtn anime-btn' onClick={() => {
              handleButtonClick({ i: 2, item: item });

              setActiveStatus(2);
            }}>Hold</button>
            <button className='__pmtRejectBtn anime-btn' onClick={() => {
              handleButtonClick({ i: 4, item: item });

              setActiveStatus(4);
            }}>Reject</button>
          </div>

          <div className='__rightSide_attachment'>
            <div className='__rs_attBx'><span>{`Requested By- ${  item?.created_by?.full_name ||"-----"}`}</span></div>
            <div className='__rs_attBx'><p>{`Attachment (${item?.file?.length})`}</p></div>
          </div>
        </div>
      ),
      action: (
        <>
          <div className="dropdown statusDrop_dwn">
            <button
              className="btn btn-secondary dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="_drpStatus _pending">
                <span className="_dotState"></span>
                {masterData?.payment_approval_status[item?.approval_status]}
              </span>
            </button>
            <ul className="dropdown-menu">
              {masterData?.payment_approval_action_list
                ?.filter((f) => f?.id != item?.approval_status)
                .map((i, index) => {
                  return (
                    <li
                      key={index}
                      onClick={() => {
                        handleButtonClick({ i: i, item: item });

                        setActiveStatus(i);
                      }}
                    >
                      <a className="dropdown-item" href="#">
                        <span className="_drpStatus _pending">
                          <span className="_dotState"></span> {i?.name}
                        </span>
                      </a>
                    </li>
                  );
                })}
            </ul>
          </div>
        </>
      ),
      totalamount: <>&#x20B9; {`${item?.total_amount}`}</>,
      requestedby: (
        <div className='__rs_attBx'>
          <span>
            {item?.created_by?.full_name || "--"}
          </span>
        </div>
      ),
    }));
    return listArray;
  };

  useEffect(() => {
    handlePaymentAprovel();
  }, [activeTab, filter, offSet]);

  const handlePaymentAprovel = async () => {
    try {
      // setIsLoading(true);
      const res = await getPayment({
        ...filter,
        offset: offSet,
        company_id: StorageService?.getCompanyId(),
        approval_status: activeTab,
        firm_id: StorageService?.getFirmId() ?? "",
      });

      if (res?.responseCode === 200) {
        setPaymentList(res?.data?.list);
        setTotalItems(res?.data?.total_record);
        setIsLoading(false);
        props?.getPaymentCount();
      } else {
        setIsLoading(false);
      }
    } catch (error) { }
  };

  const getAccountListFunc = async (item) => {
    try {
      const res = await getAccountList({
        company_id: StorageService?.getCompanyId(),
        vendor_type: item?.vendor_type,
        vendor_id: item?.vendor_detail?._id,
      });

      if (res?.responseCode === 200) {
        const details = res?.data?.bank_account?.map((item) => {
          return {
            ...item,
            label: item?.bank_name,
            value: item?._id,
          };
        });
        setAccountList(details);
      } else {
      }
    } catch (error) {
    }
  };

  const submitTestHandle = (status) => {
    switch (status) {
      case 1:
        return "Mark Document Ready";
      case 2:
        return "Intransit";
      case 3:
        return "At Party Point";
      case 4:
        return "Delivered";
      case 5:
        return "Bill Raised";

      default:
        break;
    }
  };

  const handleButtonClick = (status) => {

    switch (status?.i?.id) {
      case 1:
        setIsOpenSmallModal(true);
        setTextState(status);
        break;
      case 2:
        setIsOpenSmallModal(true);
        setTextState(status);
        break;
      case 3:
        setIsOpenSmallModal(true);
        setTextState(status);
        break;
      case 4:
        setIsOpenSmallModal(true);
        setTextState(status);
        break;
      case 5:
        if (status?.item?.type == 1) {
          const freightType =
            status?.item?.sub_type == 1
              ? "advance"
              : status?.item?.sub_type == 2
                ? "balance"
                : null;

          if (freightType) {
            setIsOpenFreight({
              ...isOpenFreight,
              open: true,
              type: freightType,
            });
            setDetails(status?.item);
            getAccountListFunc(status?.item);
          }
        }

        if (status?.item?.type == 2) {
          setIsOpenClaim(true);
          setDetails(status?.item);
        }

        if (status?.item?.type == 3 && status?.item?.sub_type == 1) {
          setIsOpenExpense({ ...isOpenExpense, open: true, type: "expense" });
          setDetails(status?.item);
        }
        if (status?.item?.type == 3 && status?.item?.sub_type == 2) {
          setIsOpenExpense({ ...isOpenExpense, open: true, type: "receipt" });
          setDetails(status?.item);
        }

        if (status?.item?.type == 4) {
          setIsOpenFuel({ open: true, type: "fuel_driver" });
          setDetails(status?.item);
        }

        if (status?.item?.type == 5) {
          setIsOpenPayDriver(true);
          setDetails(status?.item);
          getAccountListFunc(status?.item);
        }

        if (status?.item?.type == 7) {
          setTripChargesOpen(true);
          setDetails(status?.item);
        }

        if (status?.item?.type == 8) {
          setIsOpenGeneralExpense((s) => ({ ...s, open: true, title: "expense" }))
          setDetails(status?.item);
        }

        if (status?.item?.type == 13) {
          setIsOpenFuel({ open: true, type: "fuel_supplier" });
          setDetails(status?.item);
        }

        if (status?.item?.type == 14) {
          setIsOpenOwnClaim(true);
          setDetails(status?.item);
        }

        if (status?.item?.type == 15 && status?.item?.sub_type == 1) {
          setIsOpenOwnExpense({
            ...isOpenOwnExpense,
            open: true,
            type: "expense",
          });
          setDetails(status?.item);
        }

        if (status?.item?.type == 15 && status?.item?.sub_type == 2) {
          setIsOpenOwnExpense({
            ...isOpenOwnExpense,
            open: true,
            type: "receipt",
          });
          setDetails(status?.item);
        }

        if (status?.item?.type == 16 && status?.item?.sub_type == 1) {
          setIsOpenCharges({ ...isOpenCharge, open: true, type: "freight" });
          setDetails(status?.item);
        }

        if (status?.item?.type == 16 && status?.item?.sub_type == 2) {
          setIsOpenCharges({ ...isOpenCharge, open: true, type: "freight" });
          setDetails(status?.item);
        }

        if (status?.item?.type == 17) {
          setIsOpenPartyClaim(true);
          setDetails(status?.item);
        }

        setTextState(status);
        break;
      case 6:
        setIsOpenSmallModal(true);
        setTextState(status);
        break;

      default:
        break;
    }
  };

  const callBackApiCall = (status) => {
    if (status) {
      handlePaymentAprovel();
    }
  };

  const handlePageChange = (page) => {
    setOffset(page);
  };

  const handleDelete = async () => {

    const payload = {
      company_id: StorageService?.getCompanyId(),
      transaction_id: confirmModalShow?._id || paymentVoucherOpen?.transaction_id
    }
    try {
      setDeleteLoading(true)
      const res = await deleteTransactionApi(payload)
      if (res?.responseCode == 200) {
        toast.success(res?.responseMessage)
        setConfirmModalShow(false);
        setPaymentVoucherOpen(false)
        callBackApiCall(true)
        setDeleteLoading(false)

      } else {
        setDeleteLoading(false)
        // toast.error(res?.responseMessage)
      }
    } catch (error) {
      setDeleteLoading(false)
      toast.error(error?.message)
    }
  };



  let firstMakePayment = {
    isOpen: showMakePayment,
    closeModal: (e) => setShowMakePayment(false),
    headerPart: false,
    footerPart: true,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Make Payment",
    submitTitle: "Add Freight",
    cancelButtonTitle: "Send for Approval",
  };

  let modalProps = {
    isOpen: isOpenSmallModal,
    closeModal: (e) => setIsOpenSmallModal(false),
    lrId: textState,
    companyId: textState?.company_id,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: textState?.i?.name,
    submitTitle: textState?.i?.name,
    callBackApiCall: callBackApiCall,
    aprroveStatus: true,
  };

  let advancebalnceProps = {
    isOpen: isOpenFreight,
    closeModal: (e) => {
      setBankDetails("")
      setIsOpenFreight(false)
    },
    headerPart: false,
    footerPart: false,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Make Payment",
    submitTitle: "Complete Payment",
    detailsProps: details,
    accountListVender: accountList,
    callBackApiCall: callBackApiCall
  };

  let claimProps = {
    isOpen: isOpenClaim,
    closeModal: () => setIsOpenClaim(false),
    headerPart: false,
    footerPart: false,
    modalMainClass: "_dashCommon_Modal _lgModal",
    modalTitle: "Claim Payable to Supplier ",
    submitTitle: "Complete Payment",
    detailsProps: details,
    callBackApiCall: callBackApiCall
  };

  let otherExpenseProps = {
    isOpen: isOpenExpense.open,
    modalType: isOpenExpense.type,
    closeModal: (e) =>
      setIsOpenExpense({ ...isOpenExpense, open: false, type: "" }),
    headerPart: true,
    footerPart: false,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Other",
    submitTitle: "Complete Payment",
    detailsProps: details,
    callBackApiCall: callBackApiCall
  };

  let otherOwnExpenseProps = {
    isOpen: isOpenOwnExpense.open,
    modalType: isOpenOwnExpense.type,
    closeModal: (e) =>
      setIsOpenOwnExpense({ ...isOpenOwnExpense, open: false, type: "" }),
    headerPart: true,
    footerPart: false,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Other",
    submitTitle: "Complete Payment",
    detailsProps: details,
    callBackApiCall: callBackApiCall
  };

  let chargesProps = {
    isOpen: tripChargesOpen,
    closeModal: () => setTripChargesOpen(false),
    headerPart: false,
    footerPart: false,
    modalMainClass: "_dashCommon_Modal _lgModal",
    modalTitle: "Trip Charges ",
    submitTitle: "Complete Payment",
    detailsProps: details,
    callBackApiCall: callBackApiCall
  };

  let ownclaimProps = {
    isOpen: isOpenOwnClaim,
    closeModal: () => setIsOpenOwnClaim(false),
    headerPart: false,
    footerPart: false,
    modalMainClass: "_dashCommon_Modal _lgModal",
    submitTitle: "Complete Payment",
    detailsProps: details,
    callBackApiCall: callBackApiCall
  };

  const payDriverProps = {
    isOpen: isOpenPayDriver,
    closeModal: () => setIsOpenPayDriver(false),
    headerPart: false,
    footerPart: false,
    modalTitle: "Complete Payment",
    detailsProps: details,
    accountListVender: accountList,
    callBackApiCall: callBackApiCall
  };

  let consignorChargeProps = {
    isOpen: isOpenCharge.open,
    closeModal: (e) => setIsOpenCharges({ open: false, type: "" }),
    isOpenCharge: isOpenCharge,
    headerPart: true,
    footerPart: false,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Add Freight",
    submitTitle: "Complete Payment",
    detailsProps: details,
    callBackApiCall: callBackApiCall
  };

  let partyClaimProps = {
    isOpen: isOpenPartyClaim,
    closeModal: () => setIsOpenPartyClaim(false),
    headerPart: true,
    footerPart: false,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Complete Payment",
    detailsProps: details,
    callBackApiCall: callBackApiCall
  };

  let fuelProps = {
    isOpen: isOpenFuel,
    closeModal: (e) => setIsOpenFuel({ ...isOpenFuel, open: false, type: "" }),
    headerPart: true,
    footerPart: false,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Add Fuel",
    submitTitle: "Complete Payment",
    detailsProps: details,
    callBackApiCall: callBackApiCall
  };

  const paymentVoucherProps = {
    paymentVoucherOpen: paymentVoucherOpen,
    closeModal: () => setPaymentVoucherOpen(false),
    voucherId: paymentVoucherOpen?._id,
    oprnDeleteModal: setConfirmModalShow
  }

  let addEditGeneralExpensesModals = {
    isOpen: isOpenGeneralExpense.open,
    closeModal: (e) => setIsOpenGeneralExpense((pre) => ({ ...pre, title: "", open: false }), setDetails({})),
    modalMainClass: "_dashCommon_Modal _addExpModal",
    modalTitle: "General Expenses",
    headerPart: false,
    footerPart: true,
    sendApprovalButtonTitle: "Send for Approval",
    submitTitle: "Add General Expense",
    cancelButtonTitle: "Cancel",
    isEditDetails: { isEdit: true, ...details },
    callBackFreight: () => handlePaymentAprovel(),
    userSettingPermission: userSettingPermission,
  }

  let confirmModalProps = {
    show: confirmModalShow,
    closeModal: (e) => {
      setConfirmModalShow(false);
    },
    title: "Confirm",
    submitTitle: "Delete",
    onSubmit: handleDelete,
    confirmModal: "confirmModal",
    icon: Images.DELETEICON.default,
    isLoadding: deleteLoading,
    disabled: deleteLoading
  };


  const actionButtons = [
    {
      label: 'Approve',
      className: '__pmtApprovBtn',
      onClick: (row, index) => {

        handleButtonClick({ i: { id: 3, name: "Approve" }, item: row });

        setActiveStatus(3);
      },
      isShow: morePermissionCheck?.approve === 1
    },
    {
      label: 'Hold',
      className: '__pmtHoldBtn',
      onClick: (row, index) => {

        handleButtonClick({ i: { id: 2, name: "Hold" }, item: row });

        setActiveStatus(2);
      },
      isShow: morePermissionCheck?.on_hold == 1
    },
    {
      label: 'Reject',
      className: '__pmtRejectBtn',
      onClick: (row, index) => {

        handleButtonClick({ i: { id: 4, name: "Reject" }, item: row });

        setActiveStatus(4);
      },
      isShow: morePermissionCheck?.reject === 1
    },
    {
      label: 'Complete',
      className: '__pmtCompleteBtn',
      onClick: (row, index) => {
        handleButtonClick({
          i:
            { id: 5, name: 'Complete' }, item: row
        });

        setActiveStatus(5);
      },
      isShow: morePermissionCheck?.complete === 1
    },
    {
      label: 'Payment from CB',
      className: '__pmtPaymentBtn',
      onClick: (row, index) => {
        handleButtonClick({
          i:
            { id: 6, name: 'Payment from cb' }, item: row
        });

        setActiveStatus(6);
      },
      isShow: morePermissionCheck?.payment_from_cb === 1
    },
    // {
    //   label: 'Initiate with Bank',
    //   className: '__pmtPaymentBtn',
    //   onClick: (row, index) => {
    //     handleButtonClick({
    //       i:
    //         { id: 7, name: 'Initiate with Bank' }, item: row
    //     });

    //     setActiveStatus(7);
    //   },
    //   isShow: morePermissionCheck?.initiate_with_bank === 1
    // }
  ];

  const hasAnyPermission = (permissions, buttons) => {
    return buttons.some(button => button.isShow);
  };

  const isAnyButtonVisible = hasAnyPermission(morePermissionCheck, actionButtons);
  return (
    <>
      <div className="_transactionTable">

        <TableOfDetails
          columns={columnsDetails}
          data={accessorDetailsList(paymentList?.length ? paymentList : [])}
          isLoading={isLoading}
          actionButtons={actionButtons}
          isAnyButtonVisible={isAnyButtonVisible}
          refreshPaymentAprovel={()=>handlePaymentAprovel()}

        />
        {showMakePayment && (
          // <AddBankAccount {...firstMakePayment} />
          <MakePaymentModal {...firstMakePayment} />
        )}

        {isOpenSmallModal && <AtPartyPointModal {...modalProps} />}
      </div>
      <div className="paginationFt_avt ">
        <CustomPagination
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          currentPage={offSet}
          onPageChange={handlePageChange}
        />
      </div>
      {isOpenFreight.open && <AdvanceBalanceModal {...advancebalnceProps} />}
      {isOpenClaim && <ClaimMarketModal {...claimProps} />}
      {isOpenExpense.open && <ExpenseMarket {...otherExpenseProps} />}
      {isOpenFuel?.open && <PayFuelModal {...fuelProps} />}

      {tripChargesOpen && <TripChargesOwn {...chargesProps} />}
      {isOpenOwnClaim && <ClaimOwnModal {...ownclaimProps} />}
      {isOpenOwnExpense.open && <OtherOwnModal {...otherOwnExpenseProps} />}
      {isOpenPayDriver && <PayDriverOwn {...payDriverProps} />}

      {isOpenCharge.open && <ConsignorFreightModal {...consignorChargeProps} />}
      {isOpenPartyClaim && <PartyClaimModal {...partyClaimProps} />}
      {paymentVoucherOpen && <PaymentVoucher {...paymentVoucherProps} />}

      {isOpenGeneralExpense?.title == "expense" && <AddExpensesModal {...addEditGeneralExpensesModals} />}
      {confirmModalShow && (
        <ConfirmModalFor {...confirmModalProps}>
          <>
            <p className="_confirmPrx">
              {" "}
              Are you sure you want to delete " {"Transaction"} "{" "}
            </p>
          </>
        </ConfirmModalFor>
      )}
    </>
  );
};

export default UnderApprove;


